// // src/index.js
// import React from 'react';
// import ReactDOM from 'react-dom';
// import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
// import { LanguageProvider } from './components/Homepage/LanguageContext';
// import FooterSmallNew from './components/Footers/FooterSmallNew';
// import Index from './views/Index';
// import Contactus from './about/aboutpage/Contactus';
// import Aboutus from './about/aboutpage/Aboutus';
// import FoodMenu from './components/Homepage/FoodMenu';
// import FoodGallery from './components/Homepage/FoodGallery';
// import i18n from 'config/i18n';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'assets/styles/tailwind.css';
// import 'assets/styles/style.css';
// import HoverChange from 'components/Homepage/HoverChange';

// ReactDOM.render(
//   <BrowserRouter>
//     <React.StrictMode>
//       <LanguageProvider>
//         <Switch>
//           <Route path="/elegantcarve-homepage" exact component={Index} />
//           <Route path="/contact-us" exact component={Contactus} />
//           <Route path="/about-us" exact component={Aboutus} />
//           <Route path="/food-menu" exact component={FoodMenu} />
//           <Route path="/food-gallery" exact component={FoodGallery} />
//           <Route path="/hover-change" exact component={HoverChange} />
//           <Route path="/" exact component={Index} />
//           <Route path="/footersmall" exact component={FooterSmallNew} />
//           <Redirect from="*" to="/" />
//         </Switch>
//       </LanguageProvider>
//     </React.StrictMode>
//   </BrowserRouter>,
//   document.getElementById('root')
// );

// src/index.js
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { LanguageProvider } from "./components/Homepage/LanguageContext";
import FooterSmallNew from "./components/Footers/FooterSmallNew";
import Index from "./views/Index";
import Contactus from "./about/aboutpage/Contactus";
import ContactForm from "./about/aboutpage/ContactForm";
import Aboutus from "./about/aboutpage/Aboutus";
import FoodMenu from "./components/Homepage/FoodMenu";
import FoodGallery from "./components/Homepage/FoodGallery";
import RouteWithLoading from "./components/RouteWithLoading";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";
import "assets/styles/style.css";
import HoverChange from "components/Homepage/HoverChange";
import ScrollToTop from "components/ScrollToTop";
import Service from "components/Homepage/Service";
import Quality from "components/Homepage/Quality";

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <LanguageProvider>
        <ScrollToTop />
        <Switch>
          <RouteWithLoading
            path="/homepage"
            exact
            component={Index}
          />
          <RouteWithLoading path="/contact-us" exact component={Contactus} />
          <RouteWithLoading path="/about-us" exact component={Aboutus} />
          <RouteWithLoading path="/products" exact component={FoodMenu} />
          <RouteWithLoading path="/service" exact component={Service} />
          <RouteWithLoading path="/quality" exact component={Quality} />
          <RouteWithLoading path="/contact" exact component={ContactForm} />
          <RouteWithLoading
            path="/food-gallery"
            exact
            component={FoodGallery}
          />
          <RouteWithLoading
            path="/hover-change"
            exact
            component={HoverChange}
          />
          <RouteWithLoading path="/" exact component={Index} />
          <RouteWithLoading
            path="/footersmall"
            exact
            component={FooterSmallNew}
          />
          <Redirect from="*" to="/" />
        </Switch>
      </LanguageProvider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById("root")
);
